import { useCallback } from "react"

import { defineDataPropHook } from "../useProp"

export default function useData(data) {
  // control states
  const isEditing = useIsEditing(false)
  const isNew = useIsNew(data.isNew === true)

  // data mutable states
  const description = useDescription(data)
  const name = useName(data, {
    onChange: useCallback(() => {
      isEditing.setValue(false)
    }, [isEditing]),
  })

  return {
    name,
    description,
    isEditing,
    isNew,
  }
}

export const useName = defineDataPropHook('name')
export const useDescription = defineDataPropHook('description')
export const useIsEditing = defineDataPropHook()
export const useIsNew = defineDataPropHook()
export const useStatus = defineDataPropHook('status')
